export default {
    togglePartialPaymentInformationPopup(state, value) {
        state.isShowPartialPaymentInformationPopup = value;
    },
    toggleIsShowSubscribePopup2(state, value) {
        state.isShowSubscribePopup2 = value;
    },
};
